import React from "react";
import { UtensilsCrossed } from "lucide-react";
import { ADMIN } from "@/lib/testIds";

const modules = [
  { name: "Catégories", desc: "Burgers, Rolls, Sandwichs, Pizzas, Tandoor, Sides, Boissons, Desserts." },
  { name: "Produits", desc: "Fiches produits avec prix et photo." },
  { name: "Options", desc: "Sauces, suppléments, niveaux d'épices." },
  { name: "Ingrédients", desc: "Base partagée et gestion des allergènes." },
];

const AdminMenu = () => {
  return (
    <div data-testid={ADMIN.menu} className="space-y-6">
      <header>
        <div className="text-xs uppercase tracking-[0.22em] text-[#A1A1AA]">
          Module menu
        </div>
        <h1 className="mt-1 text-3xl sm:text-4xl font-bold tracking-tight">
          Menu & Produits
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-[#A1A1AA]">
          Gérez ici la carte du restaurant : catégories, produits, options et
          ingrédients.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2">
        {modules.map((m) => (
          <div
            key={m.name}
            className="rounded-xl border border-[#262626] bg-[#171717] p-6 le11-shadow-card"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-[#0A0A0A] border border-[#262626] text-[#FF9500]">
                <UtensilsCrossed size={16} />
              </span>
              <h3 className="text-lg font-semibold tracking-tight">{m.name}</h3>
            </div>
            <p className="mt-3 text-sm text-[#A1A1AA]">{m.desc}</p>
            <div className="mt-4 text-[11px] uppercase tracking-[0.22em] text-[#FF9500] font-semibold">
              Ouverture prochaine
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminMenu;
